<template>
	<div id="app">
		<background />
		<div id="content">
			<router-view role="application"></router-view>
			<keep-alive>
				<component :is="gameClientComponent"/>
			</keep-alive>
			<keep-alive>
				<api-client></api-client>
			</keep-alive>
		</div>
		<debug-panel v-if="showDebugPanel"></debug-panel>
		<!-- <version-info></version-info> -->
		<transition name="fade">
			<error-container :errorIcon="errorIcon" v-if="errorMessage" v-on:click.native="onErrorDismiss">
				{{ errorMessage }}
			</error-container>
		</transition>
	</div>
</template>

<script>
	import Background from '@/components/background';

    import GameClientOnline from '@/components/app-components/game-client'
    import GameClientOffline from '@/components/app-components/game-client-offline'

    import ApiClient from '@/components/app-components/api-client'
    import DebugPanel from '@/components/debug/debug-panel'
    import VersionInfo from '@/components/version-info'
    import {$eBus} from '@/event-bus/index'
    import GameClientEvent from '@/enum/GameClientEvent'
    import GameClientType from '@/enum/GameClientType'
    import ErrorContainer from '@/components/error-container'
    import AppConfig from '@/app-config'

    import * as MutationTypes from '@/store/mutation-types'
    import {mapGetters} from 'vuex'

    export default {
		name: 'app',
		components: {
			Background,
			'game-client-online': GameClientOnline,
			'game-client-offline': GameClientOffline,
			DebugPanel,
			ApiClient,
			ErrorContainer,
			VersionInfo
		},

		mounted() {
			$eBus.$on(GameClientEvent.Close, this.onGameClientClose)
		},
		beforeDestroy() {
			$eBus.$off(GameClientEvent.Close, this.onGameClientClose)
		},
		methods: {
			onGameClientClose() {
				let redirectUrl = this.gameClientCloseRedirectUrl || '/'

				console.log('Game client connection was closed - redirecting to ' + redirectUrl)

				// Make sure we disable navigation guard because something obviously went wrong
				this.$store.commit(MutationTypes.SET_NAVIGATION_GUARD_ENABLED, false)

				// If the game client connection closes, let's go back to the index page
				this.$router.push(redirectUrl)
			},
			onErrorDismiss() {
				this.$store.commit(MutationTypes.CLEAR_ERROR_MESSAGE)
			}
		},
		computed: {
			...mapGetters({
				gameClientType: 'getGameClientType',
				gameClientCloseRedirectUrl: 'getGameClientCloseRedirectUrl',
				errorMessage: 'getErrorMessage',
				errorIconType: 'getErrorIcon',
				currentTheme: 'getCurrentTheme'
			}),
			gameClientComponent() {
				if (this.gameClientType === GameClientType.Online) {
					return 'game-client-online'
				} else if (this.gameClientType === GameClientType.Offline) {
					return 'game-client-offline'
				} else if (this.gameClientType) {
					console.error(`Unknown game client type "${this.gameClientType}"`);
				}

				return null
			},
			errorIcon() {
				if (this.errorIconType === 'connectionError') {
					return 'misc/connection-error.png'
				}

				return 'misc/error.png'
			},
			showDebugPanel() {
				return AppConfig.showDebugPanel
			}
		}
	}
</script>

<style lang="less">
	@import "~@less/main.less";
	@import "~@less/variables.less";
</style>
